export default "__VITE_ASSET__DMfErHc8__"